const generateRandomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export const venueLog = async (venueId) => {
    const analysisApi = `${process.env.REACT_APP_API_BASE_URL}/public/access/venue`;
    const userIdentifier = localStorage.getItem('userIdentifier') || generateRandomString(16);

    if (!localStorage.getItem('userIdentifier')) {
        localStorage.setItem('userIdentifier', userIdentifier);
    }

    const payload = {
        venue_id: venueId,
        userAgent: navigator.userAgent,
        width: window.innerWidth,
        height: window.innerHeight,
        pixelRatio: window.devicePixelRatio || 1,
        maxTouchPoints: navigator.maxTouchPoints || 0,
        hardwareConcurrency: navigator.hardwareConcurrency || 4,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userIdentifier: localStorage.getItem('userIdentifier') || userIdentifier
    };

    try {
        const response = await fetch(analysisApi, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error('Failed to add venue analysis');
        }
    } catch (error) {
        console.error('Failed to send analysis venue data:', error);
    }
};

export const advLog = async (venueId, advId, origin) => {
    const analysisApi = `${process.env.REACT_APP_API_BASE_URL}/public/access/adv`;
    const userIdentifier = localStorage.getItem('userIdentifier') || generateRandomString(16);

    if (!localStorage.getItem('userIdentifier')) {
        localStorage.setItem('userIdentifier', userIdentifier);
    }

    const payload = {
        venue_id: venueId,
        adv_id: advId,
        userAgent: navigator.userAgent,
        width: window.innerWidth,
        height: window.innerHeight,
        pixelRatio: window.devicePixelRatio || 1,
        maxTouchPoints: navigator.maxTouchPoints || 0,
        hardwareConcurrency: navigator.hardwareConcurrency || 4,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userIdentifier: localStorage.getItem('userIdentifier') || userIdentifier,
        origin: origin
    };

    try {
        const response = await fetch(analysisApi, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error('Failed to add adv analysis');
        }
    } catch (error) {
        console.error('Failed to send analysis adv data:', error);
    }
};

// content log其实有三种类型 这个是针对内容的访问日志
export const contentLog = async (venueId, contentId) => {
    const analysisApi = `${process.env.REACT_APP_API_BASE_URL}/public/access/content`;
    const userIdentifier = localStorage.getItem('userIdentifier') || generateRandomString(16);

    if (!localStorage.getItem('userIdentifier')) {
        localStorage.setItem('userIdentifier', userIdentifier);
    }

    const payload = {
        venue_id: venueId,
        userAgent: navigator.userAgent,
        width: window.innerWidth,
        height: window.innerHeight,
        pixelRatio: window.devicePixelRatio || 1,
        maxTouchPoints: navigator.maxTouchPoints || 0,
        hardwareConcurrency: navigator.hardwareConcurrency || 4,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userIdentifier: localStorage.getItem('userIdentifier') || userIdentifier,
        type: "Content",
        content_id: contentId,
        contentId: contentId
    };

    try {
        const response = await fetch(analysisApi, {
            method: 'POST',
            keepalive: true,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error('Failed to add content analysis');
        }
    } catch (error) {
        console.error('Failed to send content venue data:', error);
    }
};

// content log其实有三种类型 这个是给主页contact点击的访问日志
export const contactLog = async (venueId, contact) => {
    const analysisApi = `${process.env.REACT_APP_API_BASE_URL}/public/access/content`;
    const userIdentifier = localStorage.getItem('userIdentifier') || generateRandomString(16);

    if (!localStorage.getItem('userIdentifier')) {
        localStorage.setItem('userIdentifier', userIdentifier);
    }

    const payload = {
        venue_id: venueId,
        userAgent: navigator.userAgent,
        width: window.innerWidth,
        height: window.innerHeight,
        pixelRatio: window.devicePixelRatio || 1,
        maxTouchPoints: navigator.maxTouchPoints || 0,
        hardwareConcurrency: navigator.hardwareConcurrency || 4,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userIdentifier: localStorage.getItem('userIdentifier') || userIdentifier,
        type: "Contact",
        contactType: contact
    };

    try {
        const response = await fetch(analysisApi, {
            method: 'POST',
            keepalive: true,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error('Failed to add content analysis');
        }
    } catch (error) {
        console.error('Failed to send content venue data:', error);
    }
};
